module.exports = __webpack_public_path__ + "media/images/menu/m4-291b22bb28975d95c86e5af6da807efb.JPG";